export {MessageDateItem as default};

/**
* Message Date Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageDateItem {
  /**
   * Raw Date
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  raw;

  /**
   * Local date
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  local;

  /**
   * Short Date
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  short;

  /**
   * Full Date
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  full;
}